import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b2f93e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calendar-container" }
const _hoisted_2 = { class: "calendar-wrapper" }
const _hoisted_3 = { class: "calendar-contents" }
const _hoisted_4 = { class: "year-month" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "day-of-week-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sunday" }, "일"),
  /*#__PURE__*/_createElementVNode("div", null, "월"),
  /*#__PURE__*/_createElementVNode("div", null, "화"),
  /*#__PURE__*/_createElementVNode("div", null, "수"),
  /*#__PURE__*/_createElementVNode("div", null, "목"),
  /*#__PURE__*/_createElementVNode("div", null, "금"),
  /*#__PURE__*/_createElementVNode("div", { class: "saturday" }, "토")
], -1 /* HOISTED */))
const _hoisted_6 = { class: "days-wrapper" }
const _hoisted_7 = ["id", "onClick", "aria-label", "onKeydown"]
const _hoisted_8 = { class: "day-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$props.hideModalBackDrop)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-backdrop",
          onClick: $setup.emitOnClickClose
        }))
      : _createCommentVNode("v-if", true),
    _createVNode(_Transition, {
      appear: "",
      name: "slide-up"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("header", _hoisted_4, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn prev", { selectable: $setup.isSelectableMonth(false) }]),
                type: "button",
                "aria-label": "이전 달 선택",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.changeMonth(false)))
              }, [
                _createVNode($setup["InlineSvg"], {
                  src: require('@/assets/icons/caret_left.svg'),
                  alt: ""
                }, null, 8 /* PROPS */, ["src"])
              ], 2 /* CLASS */),
              _createElementVNode("p", null, _toDisplayString($setup.year) + ". " + _toDisplayString($setup.formattedMonth), 1 /* TEXT */),
              _createElementVNode("button", {
                class: _normalizeClass(["btn next", { selectable: $setup.isSelectableMonth(true) }]),
                type: "button",
                "aria-label": "다음 달 선택",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeMonth(true)))
              }, [
                _createVNode($setup["InlineSvg"], {
                  src: require('@/assets/icons/caret_right.svg'),
                  alt: ""
                }, null, 8 /* PROPS */, ["src"])
              ], 2 /* CLASS */),
              (!$props.hideTodayButton)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "today-btn",
                    type: "button",
                    "aria-label": "오늘 날짜 선택",
                    onClick: $setup.onClickToday
                  }, " 오늘 "))
                : _createCommentVNode("v-if", true)
            ]),
            _hoisted_5,
            _createElementVNode("section", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dates, (date, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: index,
                  type: "button",
                  class: _normalizeClass(["day-wrapper", {
                selected: $setup.isSelectedDate(date),
                selectable: $setup.isSelectable(date),
                saturday: date.day() === 6,
                sunday: date.day() === 0,
              }]),
                  id: `day-wrapper-${index}`,
                  onClick: ($event: any) => ($setup.onClickDay(date)),
                  "aria-label": `${date.format('YYYY-MM-DD')} 날짜 선택`,
                  onKeydown: _withKeys(_withModifiers(($event: any) => ($setup.onClickDay(date)), ["prevent"]), ["enter"])
                }, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(date.format("D")), 1 /* TEXT */)
                ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_7))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createElementVNode("footer", null, [
              ($props.hasTimeSelect)
                ? (_openBlock(), _createBlock($setup["TimeSelect"], {
                    key: 0,
                    initialTime: $setup.selectedTime,
                    onOnUpdateTime: $setup.onUpdateTime
                  }, null, 8 /* PROPS */, ["initialTime"]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", { class: "btn-wrapper" }, [
                _createElementVNode("button", {
                  class: "item btn",
                  onClick: $setup.onSelectDate
                }, "선택완료")
              ])
            ])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}